import { AdminPermissions, ClientPermissions } from "./Permissions";

const OrgBasePermission = [
	AdminPermissions.ViewOrganization,
	AdminPermissions.GlobalAdmin,
];

export const Permissions = {
	Admins: [AdminPermissions.GlobalAdmin],
	GlobalAdmins: [AdminPermissions.GlobalAdmin],
	// Debt: Those permissions start with 'view' are like the pre-request of ones start with 'edit',
	// should we only check 'view' permissions then?? Also if user has 'ViewOrganization' permission then
	// other permissions that user has won't affect anything?
	OrganizationList: [...OrgBasePermission],
	OrganizationDetails: [
		...OrgBasePermission,
		AdminPermissions.EditOrganization,
	],
	OrganizationLocationList: [
		...OrgBasePermission,
		AdminPermissions.ViewOrganizationLocation,
	],
	OrganizationLocationDetails: [
		...OrgBasePermission,
		AdminPermissions.ViewOrganizationLocation,
		AdminPermissions.EditOrganizationLocation,
	],
	OrganizationRolesList: [
		...OrgBasePermission,
		AdminPermissions.ViewOrganizationRole,
	],
	OrganizationRolesDetails: [
		...OrgBasePermission,
		AdminPermissions.ViewOrganizationRole,
		AdminPermissions.EditOrganizationRole,
	],
	OrganizationReportSetting: [
		...OrgBasePermission,
		AdminPermissions.ViewOrganizationReportSetting,
		AdminPermissions.EditOrganizationReportSetting,
	],
	OrganizationCustomFieldList: [
		...OrgBasePermission,
		AdminPermissions.ViewOrganizationCustomField,
	],
	OrganizationCustomFieldDetails: [
		...OrgBasePermission,
		AdminPermissions.ViewOrganizationCustomField,
		AdminPermissions.EditOrganizationCustomField,
	],
	OrganizationUserList: [
		...OrgBasePermission,
		AdminPermissions.ViewOrganizationUser,
	],
	OrganizationUserDetails: [
		...OrgBasePermission,
		AdminPermissions.ViewOrganizationUser,
		AdminPermissions.EditOrganizationUser,
	],

	OrganizationDatasetList: [...OrgBasePermission, AdminPermissions.ViewDataset],
	OrganizationDatasetDetails: [
		...OrgBasePermission,
		AdminPermissions.ViewDataset,
		AdminPermissions.EditDataset,
	],
	OrganizationDatasetReportSetting: [
		...OrgBasePermission,
		AdminPermissions.ViewDataset,
		AdminPermissions.ViewDatasetReportSetting,
		AdminPermissions.EditDatasetReportSetting,
	],
	OrganizationDatasetCutpoints: [
		...OrgBasePermission,
		AdminPermissions.ViewDatasetCutpoints,
		AdminPermissions.EditDatasetCutpoints,
	],
	OrganizationDatasetUserList: [
		...OrgBasePermission,
		AdminPermissions.ViewDatasetUser,
		AdminPermissions.EditDatasetUser,
	],
	OrganizationDatasetUserDetails: [
		...OrgBasePermission,
		AdminPermissions.ViewDatasetUser,
		AdminPermissions.EditDatasetUser,
	],
	OrganizationDatasetBilling: [
		...OrgBasePermission,
		AdminPermissions.GlobalAdmin,
	],

	Report: [AdminPermissions.GlobalAdmin, AdminPermissions.ViewReport],
	ReportTemplate: [
		AdminPermissions.GlobalAdmin,
		AdminPermissions.ViewTemplate,
		AdminPermissions.EditTemplate,
	],
};

export const DatasetPermissions = {
	ClientsListView: [AdminPermissions.GlobalAdmin, ClientPermissions.ViewClient],
	CoreGeneral: [
		AdminPermissions.GlobalAdmin,
		ClientPermissions.ViewCoreTest,
		ClientPermissions.EditCoreTest,
	],
	CoreSkillAppraisal: [
		AdminPermissions.GlobalAdmin,
		ClientPermissions.ViewCoreTest,
		ClientPermissions.EditCoreTest,
	],
	CoreErrorEntry: [
		AdminPermissions.GlobalAdmin,
		ClientPermissions.ViewCoreTest,
		ClientPermissions.EditCoreTest,
	],
	ClientDetails: [
		AdminPermissions.GlobalAdmin,
		ClientPermissions.ViewClient,
		ClientPermissions.EditClient,
	],
	VitalsSummary: [
		AdminPermissions.GlobalAdmin,
		ClientPermissions.ViewVitalsTest,
		ClientPermissions.EditVitalsTest,
	],
	// ClientResults: ['CSVExport'] permissions in this page need to be determined
};

const Authorization = {
	requiresPermissions: (
		currentUser: CurrentUserDTO,
		permissions: string[],
		callIfAuth: any,
		callifNotAuth: any
	) => {
		if (
			currentUser !== undefined &&
			currentUser.roles !== undefined &&
			currentUser.permissions &&
			currentUser.permissions.find((p) => permissions.includes(p)) !== undefined
		) {
			return callIfAuth(currentUser);
		}
		return callifNotAuth(currentUser);
	},

	requiresDatasetPermissions: (
		currentUser: CurrentUserDTO,
		datasetPermissions: string[],
		callIfAuth: any,
		callifNotAuth: any
	) => {
		// have to exclude Global admin coz it's like cross site permission
		if (
			(currentUser.permissions &&
				currentUser.permissions.includes(AdminPermissions.GlobalAdmin)) ||
			(currentUser !== undefined &&
				currentUser.datasetPermissions &&
				currentUser.datasetPermissions.length > 0 &&
				currentUser.datasetPermissions.some((dp) =>
					dp.permissions!.some((p) => datasetPermissions.includes(p))
				)) // how to validate datasetId tho?
		) {
			return callIfAuth(currentUser);
		}
		return callifNotAuth(currentUser);
	},
};

export default Authorization;
